const Toggles = {
    OPS_PROXY_AVATARS: 'ops-proxy-avatars',
    FCP_4616_PROFILE_PROCESS_BAR: 'fcp-4616-profile-process-bar',
    FCP_4499_CHANGE_NICKNAME: 'fcp-4499-change-nickname',
    FCP_6398_MEMBERLIST_V2: 'fcp-6398-memberlist-v2',
    FCP_4726_MY_SCHOLARSHIP: 'fcp-4726-my-scholarship',
    FCP_6357_MY_SCHOLARSHIP_VUE_FORMS: 'fcp-6357-my-scholarship-vue-forms',
    FCP_5289_ONBOARDING_FEATURE_INFO: 'fcp-5289-onboarding-feature-info',
    FCP_6273_BBB_INTEGRATION: 'fcp-6273-bbb-integration',
    FCP_4753_RE_INVITE_VIA_SERVICE: 'fcp-4753-re-invite-via-service',
    OPS_PROFILING: 'ops-profiling',
    FCP_3973_TODO_LIST_WIDGET: 'fcp-3973-todo-list-widget',
    FCP_3976_TODO_LIST_SHARING: 'fcp-3976-todo-list-sharing',
};
export { Toggles };

export enum FeatureName {
    'ops-proxy-avatars' = 0,
    'fcp-4616-profile-process-bar' = 1,
    'fcp-4499-change-nickname' = 2,
    'fcp-6398-memberlist-v2' = 3,
    'fcp-4726-my-scholarship' = 4,
    'fcp-6357-my-scholarship-vue-forms' = 5,
    'fcp-5289-onboarding-feature-info' = 6,
    'fcp-6273-bbb-integration' = 7,
    'fcp-4753-re-invite-via-service' = 8,
    'ops-profiling' = 9,
    'fcp-3973-todo-list-widget' = 10,
    'fcp-3976-todo-list-sharing' = 11,
}
